import { render, staticRenderFns } from "./Project7.vue?vue&type=template&id=522a12aa&scoped=true&"
import script from "./Project7.vue?vue&type=script&lang=js&"
export * from "./Project7.vue?vue&type=script&lang=js&"
import style0 from "./Project7.vue?vue&type=style&index=0&id=522a12aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522a12aa",
  null
  
)

export default component.exports